import { zeroAddress } from 'viem'
import type { ChainConfig } from '../types'

export const ETHERLINK = {
  name: 'etherlink',
  chainId: 42793,
  averageBlockTimeSeconds: 0.5,
  explorerUrl: 'https://explorer.etherlink.com/',
  nativeAsset: {
    assetAddress: zeroAddress,
    decimals: 18,
    name: 'Tezos',
    symbol: 'XTZ',
  },
  slip44: 1729,
  wrappedNativeAsset: '0xc9B53AB2679f573e480d01e0f49e2B5CFB7a3EAb',
  blockscoutApiUrl: 'https://explorer.etherlink.com/api',
  etherscanSupported: false,
  publicRpcUrls: ['https://node.mainnet.etherlink.com', 'https://etherlink.drpc.org'],
  getPrivateRpcUrls: () => {
    const etherlink: string[] = []
    process.env.ETHERLINK_RPC_KEY &&
      etherlink.push(`https://value-xyz-mainnet-evm.octez.io?apikey=${process.env.ETHERLINK_RPC_KEY}`)
    process.env.ROUTEME_API_KEY && etherlink.push(`https://lb.routeme.sh/rpc/42793/${process.env.ROUTEME_API_KEY}`)

    return etherlink
  },
} as const satisfies ChainConfig
